const fjordThemeVariables = {
    'header__logoPath': 'images/logo/ielts.svg',
    'header__logoPath_inverted': 'images/logo/ielts-white.svg',
    'header__logoPath_yellow-on-black': 'images/logo/ielts-white.svg',
    'header__hidePreloadCaption': true,
    'header__showSkipLink': false,
    'question__wideAndLeftAlign': true,
    'question__displayTokensVertically': true,
    'stimulus__showMargins': false,
    'footer__navIcon': 'arrow',
    'footer__sectionPartPrefix': true,
    'rubric__showSectionRubric': true,
    'rubric__showQuestionRubric': true,
    'scorableItemsDash': '–',
    'options__moveFileDeliveryToInvigilator': true,
    'options__fileDeliveryIcon': 'fa-floppy-o',
};

export default fjordThemeVariables;
